var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('v-container',{staticClass:"px-0"},[_c('v-card',{staticClass:"mx-auto pt-10"},[_c('v-row',{staticClass:"mx-10"},[_c('h2',[_vm._v("Upload Drawings")])]),_c('v-row',{staticClass:"mx-10"},[_c('v-file-input',{attrs:{"show-size":"","rules":[
          function (v) { return (!!v && v.size <= 20000000) ||
            !v ||
            'File size must be smaller than 20MB'; },
          function (v) { return (!!v && v.type === 'application/pdf') ||
            !v ||
            'File must be a PDF.'; } ]},model:{value:(_vm.file),callback:function ($$v) {_vm.file=$$v},expression:"file"}})],1)],1)],1)}
var staticRenderFns = []

export { render, staticRenderFns }